/**
 * Created by pmnia on 8/30/15.
 */
(function () {
    'use strict';

    angular
        .module('app.widgets')
        .directive('obtFilterForm', function () {
            return {
                restrict: 'E',
                //templateUrl: function(elem, attr){
                //    return attr.templateUrl;
                //},
                template: '<div ng-include="templateUrl"></div>',
                scope: {
                    templateUrl: '@',
                    filtersResult: '=',
                    comboData : '=?',
                    name : '=?',
                    filterVm : '=?',
                    filterCallback : '&?'
                },
                controller: /*ngInject*/function ($scope, queryservice, dataservice, $timeout) {
                    var cbIdList = $scope.comboData;
                    $scope.options = [];
                    $scope.selectedfilters = angular.extend({}, $scope.filtersResult);
                    $scope.name = {filter:{}};
                    $scope.submitFilter = submitFilter;
                    $scope.rangeFn = {
                        dayRange : dayRange,
                        weekRange: weekRange,
                        monthRange: monthRange,
                        yearRange: yearRange,
                        openDatePicker : openDatePicker
                    };

                    if(cbIdList && cbIdList.options){
                        getOptionData();
                    }

                    function getOptionData() {
                        //queryservice.getFormOptions
                        //combobox list ID and Passthrough
                        return dataservice.form.getOptions(cbIdList.options, cbIdList.args).then(
                            function success(result){
                                $scope.options = result;
                            }
                            ,function fail(response){
                                //toaster.pop('error', 'Error', response.body ? response.body : response);
                                $scope.options = [];
                            }
                        );
                    }
                    function submitFilter() {
                        $scope.filtersResult = angular.copy($scope.selectedfilters); // $scope.selectedfilters && $scope.selectedfilters.length > 0 ? angular.copy($scope.selectedfilters) : null;
                        $scope.name.filter = $scope.filtersResult;

                        $timeout(function(){
                            if($scope.filterCallback){
                                $scope.filterCallback();
                            }
                        });

                    }
                    function dayRange (data, range, startingPoint){
                        if (angular.isUndefined(range) || !angular.isNumber(range)){
                            range = 0;
                        }
                        if(angular.isObject(data)) {
                            data.start = new Date();
                            data.end = new Date();
                            if(startingPoint && startingPoint !== 0){
                                data.start = data.start.setDate(data.start.getDate() + startingPoint);
                                data.end = data.end.setDate(data.end.getDate() + startingPoint);
                            }
                            if(range !== 0){
                                range > 0 ?
                                    data.end.setDate(data.end.getDate() + range)
                                    : data.start.setDate(data.start.getDate() + range);
                            }
                        }
                    }
                    function weekRange (data, range){
                        genericStartEndOfDate(data, range, 'week');
                    }
                    function monthRange (data, range){
                        genericStartEndOfDate(data, range, 'month');
                    }
                    function yearRange (data, range){
                        genericStartEndOfDate(data, range, 'year');
                    }
                    function genericStartEndOfDate(data, range, timeLeap) {
                        //valid choice: year, month, week, day
                        timeLeap = timeLeap || 'week';
                        if (angular.isUndefined(range) || !angular.isNumber(range)){
                            range = 0;
                        }
                        if(angular.isObject(data)) {
                            var month_selected_start = moment().add(range, timeLeap);
                            var month_selected_end= month_selected_start.clone();
                            data.start = month_selected_start.startOf(timeLeap).toDate();
                            data.end = month_selected_end.endOf(timeLeap).toDate();
                        }
                    }
                    function openDatePicker($event, values, name) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        values[name] = true;
                    }

                }
            };
        });
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/filter-form.directive.js
 ** module id = 190
 ** module chunks = 0
 **/